import type { QuerySpec } from '@helios/powersync-client-core';

// ─── Row Types ───

export interface AppointmentRow {
  id: string;
  patient_id: string | null;
  provider_id: string | null;
  service_id: string | null;
  status_id: string | null;
  category_id: string | null;
  date: string | null;
  start_time: string | null;
  duration_minutes: number | null;
  notes: string | null;
  created_at: string | null;
  updated_at: string | null;
}

// ─── Queries ───

export function qAppointments(): QuerySpec<[]> {
  return {
    key: ['appointments'] as const,
    sql: `SELECT * FROM appointments ORDER BY date ASC, start_time ASC`,
    params: [],
    watch: ['appointments'],
  };
}

export function qAppointmentsByDate(date: string): QuerySpec<[string]> {
  return {
    key: ['appointments', 'by-date', date] as const,
    sql: `SELECT * FROM appointments WHERE date = ? ORDER BY start_time ASC`,
    params: [date],
    watch: ['appointments'],
  };
}

export function qAppointmentsByDateRange(
  startDate: string,
  endDate: string,
): QuerySpec<[string, string]> {
  return {
    key: ['appointments', 'by-range', startDate, endDate] as const,
    sql: `SELECT * FROM appointments WHERE date >= ? AND date <= ? ORDER BY date ASC, start_time ASC`,
    params: [startDate, endDate],
    watch: ['appointments'],
  };
}

export function qAppointmentsByProvider(
  providerId: string,
  date: string,
): QuerySpec<[string, string]> {
  return {
    key: ['appointments', 'by-provider', providerId, date] as const,
    sql: `SELECT * FROM appointments WHERE provider_id = ? AND date = ? ORDER BY start_time ASC`,
    params: [providerId, date],
    watch: ['appointments'],
  };
}

export function qAppointmentsByPatient(patientId: string): QuerySpec<[string]> {
  return {
    key: ['appointments', 'by-patient', patientId] as const,
    sql: `SELECT * FROM appointments WHERE patient_id = ? ORDER BY date DESC, start_time ASC`,
    params: [patientId],
    watch: ['appointments'],
  };
}
